import apiClient from './api';

export interface AdminLoginRequest {
  loginId: string;
  password: string;
}

export interface AdminLoginResponse {
  accessToken: string;
}

export interface AdminMeResponse {
  name: string;
  university: {
    id: number;
    name: string;
  };
}

export interface AdminRegisterRequest {
  loginId: string;
  name: string;
  password: string;
  universityId: number;
}

export const adminAuthService = {
  login: async (credentials: AdminLoginRequest): Promise<AdminLoginResponse> => {
    const response = await apiClient.post<AdminLoginResponse>(
      '/admin/auth/login',
      credentials
    );
    return response.data;
  },

  getMe: async (): Promise<AdminMeResponse> => {
    const response = await apiClient.get<AdminMeResponse>('/admin/me', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response.data;
  },

  register: async (data: AdminRegisterRequest): Promise<void> => {
    await apiClient.post('/admin/register', data);
  },

  isAdminAuthenticated: (): boolean => {
    return !!localStorage.getItem('accessToken');
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    window.location.href = '/admin/login';
  },
};
